import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, Package, FolderKanban, UserCog, LogOut, ScrollText, Mail } from "lucide-react";

const links = [
  { to: "/studio", end: true, label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/studio/projects", label: "Projects", icon: FolderKanban, testid: "nav-projects" },
  { to: "/studio/clients", label: "Clients", icon: Users, testid: "nav-clients" },
  { to: "/studio/packages", label: "Packages", icon: Package, testid: "nav-packages" },
  { to: "/studio/users", label: "Users", icon: UserCog, testid: "nav-users" },
  { to: "/studio/demo-requests", label: "Demo requests", icon: Mail, testid: "nav-demo-requests" },
  { to: "/studio/audit", label: "Audit log", icon: ScrollText, testid: "nav-audit" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-[#FAFAF7] text-zinc-900 flex">
      <aside className="w-60 shrink-0 border-r border-zinc-200 bg-white px-4 py-6 flex flex-col">
        <div className="flex items-center gap-2 px-2 mb-8">
          <div className="h-2.5 w-2.5 rounded-full bg-[#C4A47C]" />
          <span className="font-display font-medium tracking-tight">Projevista Studio</span>
        </div>
        <nav className="flex flex-col gap-0.5">
          {links.map(({ to, end, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition ${
                  isActive ? "bg-zinc-900 text-white" : "text-zinc-600 hover:bg-zinc-100"
                }`
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto border-t border-zinc-200 pt-4">
          <div className="px-2 text-xs text-zinc-500 mb-2">Signed in as</div>
          <div className="px-2 text-sm font-medium truncate" data-testid="admin-user-email">{user?.email}</div>
          <button
            onClick={onLogout}
            data-testid="admin-logout"
            className="mt-3 w-full inline-flex items-center gap-2 px-3 py-2 rounded-md text-sm text-zinc-600 hover:bg-zinc-100 transition"
          >
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
